import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const StatsChart = ({ rows }) => {
  const intl = useIntl();
  const theme = useTheme();
  const width = [...theme.breakpoints.keys].reduce((cur, key) => {
    return useMediaQuery(theme.breakpoints.up(key)) ? key : cur;
  }, 'xs');

  const renderChart = () => {
    const margin = width === 'xs' ? 16 : 32;
    const data = new window.google.visualization.DataTable();
    data.addColumn('date', 'Date');
    data.addColumn(
      'number',
      intl.formatMessage({
        id: 'Visits',
        defaultMessage: 'Visits',
      }),
    );

    data.addRows((rows || []).map(({ date, visits }) => [new Date(date), visits]));

    const chart = new window.google.visualization.LineChart(
      document.getElementById('statsViewsChart'),
    );

    const options = {
      title: intl.formatMessage({
        id: 'Visits per day',
        defaultMessage: 'Visits per day',
      }),
      legend: 'none',
      hAxis: {
        format: 'd LLL',
        slantedText: width === 'xs',
      },
      chartArea: {
        left: margin * 2,
        right: margin,
        top: 32,
      },
    };

    chart.draw(data, options);
  };

  const setCallback = () => {
    if (window.google && window.google.charts) {
      window.google.charts.setOnLoadCallback(renderChart);

      return;
    }

    setTimeout(() => {
      setCallback();
    }, 1000);
  };

  React.useEffect(() => {
    setCallback();
  }, []);

  React.useEffect(() => {
    if (window.google && window.google.charts) {
      renderChart();
    }
  }, [width]);

  return (
    <div
      id="statsViewsChart"
      style={{
        width: '100%',
        height: 240,
        marginTop: 16,
        zIndex: 7777,
      }}
    />
  );
};

StatsChart.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      visits: PropTypes.number.isRequired,
    }),
  ),
};

export default StatsChart;
